import type {
    OutputInterface,
    ProductVariablesInterface
} from '@pylot-data/api/operations/get-product'
import { productUpCrosellQuery } from 'stores/ooka_usa_store/framework/pylot/hooks/product/graphql/productDetailQuery'
import { SwrUseQueryOutput, useQuery } from '@pylot-data/hooks/use-query'
import { RequestInit } from '@vercel/fetch'
import { SWRConfiguration } from 'swr'

export enum ProductType {
    CONFIGURABLE_PRODUCT = 'ConfigurableProduct',
    SIMPLE_PRODUCT = 'SimpleProduct',
    GROUPED_PRODUCT = 'GroupedProduct',
    GIFT_CARD_PRODUCT = 'GiftCardProduct',
    DOWNLOADABLE_PRODUCT = 'DownloadableProduct',
    BUNDLE_PRODUCT = 'BundleProduct',
    VIRTUAL_PRODUCT = 'VirtualProduct'
}

export type UseProductFetchReturn<ProductType> = {
    product: ProductType
} & SwrUseQueryOutput<OutputInterface>

export type UseProductFetch<ProductType> = (
    productOptions: {
        productUrl: string
        productQuery?: string | undefined
    },
    swrOptions?: SWRConfiguration,
    fetchOptions?: RequestInit
) => UseProductFetchReturn<ProductType>

export const useUpCrosellProductsFetch: UseProductFetch<any> = (
    { productUrl, productQuery = productUpCrosellQuery },
    swrOptions,
    fetchOptions
) => {
    // useQuery to fetch data
    const SWRResult = useQuery<ProductVariablesInterface, OutputInterface>(
        productQuery,
        {
            filter: {
                url_key: {
                    eq: productUrl
                }
            }
        },
        swrOptions,
        fetchOptions
    )

    const product = SWRResult.data?.data?.productDetail?.items[0]!

    return {
        product,
        ...SWRResult
    }
}
